import { Checkbox, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import "../../Users/users.css";
import { useTranslation } from "react-i18next";

type UsersListProps = {
  loading: boolean;
  handleCheckbox: (checkedId: number) => void;
  usersNotInRole: any;
  checkedIds: number[];
  tableKey: number;
};
interface UserListModalInterface {
  fullName: string;
  id: string;
}
export const AllUsersListModal = ({
  loading,
  handleCheckbox,
  usersNotInRole,
  checkedIds,
  tableKey,
}: UsersListProps) => {
  const { t } = useTranslation("common");

  const columns: ColumnsType<UserListModalInterface> = [
    {
      title: `${t("name")}`,
      dataIndex: "fullName",
      key: "fullName",
      width: "25rem",
      className: "table-header",
    },
    {
      title: `${t("user-id")}`,
      dataIndex: "id",
      key: "id",
      width: "5rem",
      className: "table-row",
    },
    {
      title: `${t("add")}`,
      key: "id",
      render: (record) => {
        return (
          <Checkbox
            value={record.id}
            checked={checkedIds.includes(record.id)}
            onChange={() => handleCheckbox(record.id)}
          />
        );
      },
    },
  ];

  return (
    <>
      <Table
        key={tableKey}
        className="users-list"
        columns={columns}
        loading={loading}
        dataSource={usersNotInRole}
        rowKey={(record) => record.id}
      />
    </>
  );
};

// to do:

// delete users
